// @flow

import SchemaActions from '../actions/SchemaActions';
import WebApi from '../WebApi';

let SchemaSource = {
	fetchSchema(schema) {
		return {
			remote(state, schema) {
				return WebApi.getSchema(schema);
			},
			
			local() {
				return null;
			},
			
			success: SchemaActions.fetchSchemaDone,
			error: SchemaActions.fetchSchemaFailed
		};
	}
};

export default SchemaSource;
